import { render, staticRenderFns } from "./JcdcCheckboxSimple.vue?vue&type=template&id=b278c544"
import script from "./JcdcCheckboxSimple.vue?vue&type=script&lang=ts"
export * from "./JcdcCheckboxSimple.vue?vue&type=script&lang=ts"
import style0 from "./JcdcCheckboxSimple.vue?vue&type=style&index=0&id=b278c544&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports